import { render, staticRenderFns } from "./Templatemessage.vue?vue&type=template&id=77c5883f&scoped=true"
import script from "./Templatemessage.vue?vue&type=script&lang=js"
export * from "./Templatemessage.vue?vue&type=script&lang=js"
import style0 from "./Templatemessage.vue?vue&type=style&index=0&id=77c5883f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c5883f",
  null
  
)

export default component.exports